// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"_2vzkyj"};